import type { Jast } from '@atlaskit/jql-ast';

export const getPrimarySortDirection = (jast: Jast) =>
	jast.query?.orderBy?.fields[0]?.direction?.value;
